import {
    BEAUTY,
    PerfectCorpBeautyProductType,
    PerfectCorpJewelryAndWatchProductType,
    VtoType,
} from "@hermes/api-model-virtual-try-on";

import {
    SINGLE_PRODUCT_PAGE,
    VTO_CONFIGURATION_UNDEFINED,
    VtoPageType,
} from "../constants/vto.constant";
import {
    LocalizedVtoCategory,
    LocalizedVtoSubcategory,
    NO_CATEGORY,
    NO_SELECT,
    NO_SUBCATEGORY,
    SkuApplied,
} from "../model/localized-vto-category.model";
import {
    VtoConfigurationState,
    VtoModalStatus,
    VtoSdkError,
    CurrentVtoSku,
    VtoCameraDimension,
} from "../types/vto.types";

export interface VtoState {
    vtoConfig: VtoConfigurationState;
    isApproval: boolean;
    modalStatus: VtoModalStatus;
    sdkError: VtoSdkError;
    cameraDimension: VtoCameraDimension;
    localizedVtoCategories: LocalizedVtoCategory[];
    currentVtoSku: CurrentVtoSku;
    currentVtoType: VtoType;
    currentSkuType:
        | PerfectCorpBeautyProductType
        | PerfectCorpJewelryAndWatchProductType
        | string;
    activeCategory: LocalizedVtoCategory;
    activeSubcategory: LocalizedVtoSubcategory;
    displayLearnMoreLink: boolean;
    pageType: VtoPageType;
    skuApplied: SkuApplied;
}

export const initialState: VtoState = {
    vtoConfig: VTO_CONFIGURATION_UNDEFINED,
    isApproval: false,
    modalStatus: VtoModalStatus.NONE,
    sdkError: VtoSdkError.NO_ERROR,
    cameraDimension: { width: 0, height: 0 },
    localizedVtoCategories: [],
    currentVtoSku: NO_SELECT,
    currentSkuType: NO_SELECT,
    currentVtoType: BEAUTY,
    activeCategory: NO_CATEGORY,
    displayLearnMoreLink: false,
    activeSubcategory: NO_SUBCATEGORY,
    pageType: SINGLE_PRODUCT_PAGE,
    skuApplied: {},
};
